import React, { useState } from 'react';
import { Share2 } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';
import { api } from '@/lib/api';
import { ShareDialog } from '@/components/ShareDialog';

const LABEL = { es: 'Compartir', en: 'Share', de: 'Teilen' };
const isMobile = () => typeof navigator !== 'undefined' && /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

/** kind: app | p | e | a | t | w | b. variant: 'round' (sobre foto) · 'ghost' (icono) · 'text' (icono + texto) */
export const ShareButton = ({ kind, itemId, variant = 'ghost', className = '', size = 20, testId }) => {
  const { language } = useLanguage();
  const [open, setOpen] = useState(false);
  const record = (channel) => api.recordShare({ kind, item_id: itemId || null, channel, lang: language }).catch(() => {});

  const onClick = async (e) => {
    e.stopPropagation?.();
    if (navigator.share && isMobile()) {
      try {
        const { data } = await api.getShareLink(kind, itemId, language);
        await navigator.share({ title: data.title, text: data.text, url: data.url });
        record('native');
        return;
      } catch (err) {
        if (err?.name === 'AbortError') return;
      }
    }
    setOpen(true);
  };

  const base = {
    round: 'w-10 h-10 rounded-full flex items-center justify-center shadow-lg bg-white/90 backdrop-blur-sm text-gray-600 hover:text-[#38B2AC] transition-colors',
    ghost: 'p-2 text-gray-500 hover:text-[#38B2AC] transition-colors',
    text: 'inline-flex items-center gap-2 text-sm font-semibold text-[#38B2AC] hover:text-[#2C8F8A] transition-colors',
  }[variant];

  return (
    <>
      <button onClick={onClick} className={`${base} ${className}`} aria-label={LABEL[language] || LABEL.es} data-testid={testId || `share-btn-${kind}`}>
        <Share2 size={size} />
        {variant === 'text' && <span>{LABEL[language] || LABEL.es}</span>}
      </button>
      <ShareDialog open={open} onOpenChange={setOpen} kind={kind} itemId={itemId} language={language} onShared={record} />
    </>
  );
};

export default ShareButton;
